declare namespace $ {

	type $shm_ba_mention_stats_task_list_head__title_shm_ba_mention_stats_task_list_1 = $mol_type_enforce<
		ReturnType< $shm_ba_mention_stats_task_list['title'] >
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['title'] >
	>
	type $shm_ba_mention_stats_task_list_head__filter_shm_ba_mention_stats_task_list_2 = $mol_type_enforce<
		ReturnType< $shm_ba_mention_stats_task_list['filter'] >
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['filter'] >
	>
	type $shm_ba_mention_stats_task_list_head__add_shm_ba_mention_stats_task_list_3 = $mol_type_enforce<
		ReturnType< $shm_ba_mention_stats_task_list['add'] >
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['add'] >
	>
	type $shm_ba_mention_stats_task_list_head__search_showed_shm_ba_mention_stats_task_list_4 = $mol_type_enforce<
		ReturnType< $shm_ba_mention_stats_task_list['search_showed'] >
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['search_showed'] >
	>
	type $shm_ba_mention_stats_task_list_head__Close_shm_ba_mention_stats_task_list_5 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['Close'] >
	>
	type $shm_ba_mention_stats_task_list_head__Settings_shm_ba_mention_stats_task_list_6 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_ba_mention_stats_task_list_head['Settings'] >
	>
	export class $shm_ba_mention_stats_task_list extends $shm_service_task_list {
		filter( next?: string ): string
		search_showed( ): boolean
		task_add( next?: any ): any
		task_id( next?: string ): string
		List_head( ): $shm_ba_mention_stats_task_list_head
		task_title_rows( id: any): readonly(any)[]
		add( next?: ReturnType< $shm_ba_mention_stats_task_list['task_add'] > ): ReturnType< $shm_ba_mention_stats_task_list['task_add'] >
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map